import { ApiFetcher } from '@ts-rest/core';
import React, { createContext, useContext, useMemo } from 'react';

import { TsRestClient, createTsRestClient } from './client';

type Clients = {
  tsRestClient: TsRestClient;
};

const apiClientContext = createContext<Clients | undefined>(undefined);

export const useApiClient = () => {
  const context = useContext(apiClientContext);
  if (!context) {
    throw new Error('Tried to access ApiClientContext outside of provider');
  }
  return context.tsRestClient;
};

const { Provider } = apiClientContext;

export const ApiClientContextProvider: React.FC<{
  baseUrl: string;
  children: React.ReactNode;
  clientOptions?: {
    credentials?: RequestCredentials;
    customFetch?: ApiFetcher;
  };
}> = ({ baseUrl, children, clientOptions }) => {
  const value = useMemo(() => {
    return {
      tsRestClient: createTsRestClient(baseUrl, clientOptions),
    };
  }, [baseUrl, clientOptions]);

  return <Provider value={value}>{children}</Provider>;
};
